import { ReactNode } from 'react';

import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

import { PillTabs, PillTabsProps } from '@components/pill-tabs';
import { theme } from '@styles/theme';

import { PageContent } from 'components/Page';

interface QuickfilterItem {
  count: number;
  label: string;
  render(): ReactNode;
}

type Props = Omit<PillTabsProps, 'children'> & {
  items: Array<QuickfilterItem>;
};

export const Quickfilter = observer<Props>(function Quickfilter(props) {
  const { items, ...rest } = props;
  return (
    <PillTabs {...rest}>
      {({ selectedIndex }) => (
        <>
          <TabsWrapper>
            {items.map((item) => (
              <PillTabs.Tab key={item.label} count={item.count} label={item.label} />
            ))}
          </TabsWrapper>
          <PanelWrapper>
            <PillTabs.Panels>
              {items.map((item, index) => (
                <PillTabs.Panel tabIndex={-1} key={item.label}>
                  {selectedIndex === index && item.render()}
                </PillTabs.Panel>
              ))}
            </PillTabs.Panels>
          </PanelWrapper>
        </>
      )}
    </PillTabs>
  );
});

const PanelWrapper = styled(PageContent)({
  padding: 0,
  overflowX: 'auto',
});

const TabsWrapper = styled(PillTabs.Tabs)({
  backgroundColor: theme.color.white100,
  padding: '1rem 1.5rem',
  borderBottom: `0.0625rem solid ${theme.color.purpleTrans10}`,
  '@media(max-width: 768px)': {
    padding: '0rem 1.5rem 1rem 1.5rem',
  },
});
